// extracted by mini-css-extract-plugin
export default {"label":"PaymentComment_label__9btfs","comment_description":"PaymentComment_comment_description__zNO-Q"};